import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LoginComponent } from './components/login/login.component'
import { MessagesModule } from 'primeng/messages'
import { ButtonModule } from 'primeng/button'
import { FormsModule } from '@angular/forms'
import { TooltipModule } from 'primeng/tooltip'
import { InputTextModule } from 'primeng/inputtext'
import { JmlLibModule } from '../jml-lib.module'
import { ConnectionFailedComponent } from './components/connection-failed/connection-failed.component'
import { DialogModule } from 'primeng/dialog'
import { ReactivateTokenDialogComponent } from './components/reactivate-token-dialog/reactivate-token-dialog.component'
import { GlobalClickDirective } from './directives/global-click.directive'

@NgModule({
  declarations: [LoginComponent, ConnectionFailedComponent, ReactivateTokenDialogComponent, GlobalClickDirective],
  imports: [
    ButtonModule,
    CommonModule,
    FormsModule,
    InputTextModule,
    MessagesModule,
    JmlLibModule,
    TooltipModule,
    DialogModule
  ],
  exports: [ReactivateTokenDialogComponent, GlobalClickDirective]
})
export class AuthModule {}
